<template>
  <div class="article-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>文章管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          size="small"
          v-model="key"
        ></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div class="add"> <el-button type="primary" size="small" @click="goTo('/article-add')">+ 添加文章</el-button></div>
    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          prop="title"
          label="文章名称">
        </el-table-column>
        <el-table-column
          prop="c_time"
          label="发布时间">
        </el-table-column>
        <el-table-column
          prop="id"
          label="操作">
          <template slot-scope="scope">
            <el-button type="primary"  size="small" @click="goTo('/article-edit',scope.row.id)">编辑</el-button>
            <el-button type="danger"  size="small" @click="deleteArticle(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        pages:1,
        limit: 10,
        key: '',
        tableData: [],
        total:0
      }
    },
    methods: {
      getList(){
        this.$get('/v1/admin/article?&pages=' + this.pages + '&limit=' + this.limit+ '&key=' + this.key, {})
          .then((res) => {
            if (res.data.status === 'success') {
              this.tableData = res.data.data.data;
              this.total = res.data.data.total;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      Query(){
        this.pages = 1;
        this.getList();
      },
      deleteArticle(id){
        this.$confirm('确定删除当前文章？', () => {
          this.$delete('/v1/admin/article', {id: id})
            .then((res) => {
              if (res.data.status === 'success') {
                this.getList();
              } else {
                this.$msg(res.data.msg)
              }
            });
        })
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex %2 === 1) {
          return '';
        } else {
          return 'success-row';
        }
      },
      handleSizeChange(val) {
        this.limit = val;
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pages = val;
        this.getList()
        console.log(`当前页: ${val}`);
      },
      goTo(path,id){
        this.$router.push({
          path:path,
          query:{
            id:id
          }
        })
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .article-list
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 250px
        margin-right 20px
      .add
        padding-left 100px

    .list
      min-height 550px
      border 1px solid #EBEEF5
      .edit_icon
        width 20px
        height 20px
        margin-left 16px
        border 1px solid  #ccc
        border-radius 4px

    .block
      margin-top: 10px;

</style>



// WEBPACK FOOTER //
// src/pages/ArticleManage/ArticleList.vue